import { includes } from 'lodash-es'

export function unshiftSetToArray(arr, dataset) {
  for (let index = dataset.length - 1; index !== -1; index--) {
    const val = dataset[index]
    unshiftToArray(arr, val)
  }
  return arr
}

export function delSetFromArray(arr, dataset) {
  for (let index = 0, length = dataset.length; index !== length; index++) {
    const val = dataset[index]
    delFromArray(arr, val)
  }
  return arr
}

export function addSetToArray(arr, dataset) {
  for (let index = 0, length = dataset.length; index !== length; index++) {
    const val = dataset[index]
    addToArray(arr, val)
  }
  return arr
}

export function replaceArray(origArray, dataset) {
  origArray.length = dataset.length
  for (let index = 0, length = dataset.length; index !== length; index++) {
    origArray[index] = dataset[index]
  }
  return origArray
}

export function unshiftToArray(arr, val) {
  const index = arr.indexOf(val)
  if (index === -1) {
    arr.unshift(val)
  }

  return val
}

export function delFromArray(arr, val) {
  const index = arr.indexOf(val)
  if (index !== -1) {
    arr.splice(index, 1)
  }

  return arr.indexOf(val) === -1
    ? val
    : delFromArray(arr, val)
}

export function addToArray(arr, val) {
  const index = arr.indexOf(val)
  if (index === -1) {
    arr.push(val)
  }

  return val
}

export function isSorted(arr, diff) {
  if (arr.length < 2) {
    return true
  }

  for (let index = 1, length = arr.length; index !== length; index++) {
    const prev = arr[index - 1]
    const next = arr[index]
    if (diff(prev, next) > 0) {
      return false
    }
  }

  return true
}

export function unsortedIsEqual(aArr, bArr) {
  if (aArr.length !== bArr.length) {
    return false
  }

  for (let index = 0, length = aArr.length; index !== length; index++) {
    const aElm = aArr[index]
    const bIndex = bArr.indexOf(aElm)
    if (bIndex === -1) {
      return false
    }
  }

  return true
}

export function includesAll(arr, values) {
  if (arr.length < values.length) {
    return false
  }

  for (let index = 0, length = values.length; index !== length; index++) {
    const val = values[index]
    if (!includes(arr, val)) {
      return false
    }
  }

  return true
}

export function withoutOnce(array, ...values) {
  const result = []

  for (const elm of array) {
    const index = values.indexOf(elm)
    if (index !== -1) {
      values.splice(index, 1)
    } else {
      result.push(elm)
    }
  }

  return result
}
